<template>
  <div id="app" class="box">
    <main-menu />   
  </div>
</template>

<script>
import MainMenu from '@/components/menu/Menu.vue'

export default {
  name: 'app',
  components: {
     MainMenu,
  }
}
</script>

<style scoped>
.box {
  display: flex;
  flex-flow: column;
  height: 100%;
  background-color: black;
}
</style>
